import Cookies from 'js-cookie'
import i18n from '@/i18n'
import { windowOpen } from './browser'

/**
 * 优先从链接上取adminTicket，否则从cookie取
 * @returns
 */
export function getAdminTicket() {
  return new URL(location.href).searchParams.get('adminTicket') || Cookies.get('authorization')
}

/**
 * 跳转到oneclub，携带adminTicket和lang
 * @param key
 * @param replace
 */
export function jumpToOneclub(jumpUrl: string | { url: string; params: Record<string, string> }, replace?: boolean) {
  let url = null
  if (typeof jumpUrl === 'string') {
    url = new URL(jumpUrl)
  } else if (typeof jumpUrl === 'object' && jumpUrl.url) {
    url = new URL(jumpUrl.url)
  }

  const authorization = getAdminTicket()
  if (authorization) url.searchParams.append('adminTicket', authorization)
  if ((jumpUrl as any).params) {
    Object.keys((jumpUrl as any).params).forEach((param) => {
      url.searchParams.append(param, (jumpUrl as any).params[param])
    })
  }

  const lang = i18n.language
  url.searchParams.append('lang', lang)

  const link = url.href
  return replace ? window.location.replace(link) : windowOpen(link)
}
